$(document).on('turbo:load turbo:render fieldsAdded', () => {
    let i = $('.multi-select');
    i.each((index, element) => {
        let $el = $(element);
        let placeholder = $el.data('search-placeholder');
        let dropdown = $el.data('dropdown');
        let options = $el.data('options');

        //@ts-ignore
        $el.select2({
            placeholder: placeholder,
            theme: "bootstrap-5",
            dropdownParent: $(dropdown),
            options: options,
            minimumInputLength: 0
        });
    });


    i.on('select2:open', (e) => {
        let selected_ids = 123;
        let filteredResults = $(".multi-select").val();
        let dropdown = $(".multi-select").data().dropdown;
        $(dropdown).each
        // data.message.filter(value => !$(".multi-select").val().includes(value._id));
    });

});